module.exports = __webpack_public_path__ + "media/assets/images/logo-corporate-0fda350c17fab62921af1d5e3eb382a5.png";